/*
 * @Author: Json Chen
 * @Date: 2021-09-27 18:49:00
 * @LastEditTime: 2022-06-15 14:14:59
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/DirectDiscount/Detail/Destination/index.tsx
 */
import { get } from 'lodash';
import React from 'react';
import { Form, RadioGroup, RadioItem } from 'src/components/Antd';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import RegionTable from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/RegionTable';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Item = Form.Item;

export enum EDestinationType {
  All = 'All',
  Specific = 'Specific',
}
const _base = 'discountMethod';
const scope = [_base, 'destinationType'];
const regions = [_base, 'regions'];

const Destination = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disableEdit } = props;
  return (
    <SectionWrapper
      containerClassName={`${css.sectionContainer} ${css.sectionContainerWeights}`}
      title={getI18n(
        'salesChannelDirectDiscount.discountValueship.destination',
      )}>
      <Item
        name={scope}
        rules={[{ required: true, message: 'Please select a value' }]}>
        <RadioGroup className={css.radioGroup} disabled={disableEdit}>
          <RadioItem className={css.radio} value={EDestinationType.All}>
            {getI18n(
              'salesChannelDirectDiscount.discountValueship.allcountry/region',
            )}
          </RadioItem>
          <RadioItem value={EDestinationType.Specific}>
            {getI18n(
              'salesChannelDirectDiscount.discountValueship.specificcountry/region',
            )}
          </RadioItem>
        </RadioGroup>
      </Item>
      <Item
        shouldUpdate={(p, c) => {
          const pV = get(p, scope);
          const cV = get(c, scope);
          return pV !== cV;
        }}>
        {({ getFieldValue }) => {
          const shouldDisplay =
            getFieldValue(scope) === EDestinationType.Specific;
          if (shouldDisplay) {
            return (
              <div className={css.destinationTableContainer}>
                <Item
                  name={regions}
                  rules={[
                    {
                      validator: async (x, value) => {
                        if ((value || []).length < 1) {
                          return Promise.reject(
                            new Error(
                              getI18n(
                                'general.advancedFilters.commonRadioMulSelect.selectItem',
                              ),
                            ),
                          );
                        }
                      },
                    },
                  ]}>
                  <RegionTable
                    tableId={'SalesChannelDiscountDirectRegionTable'}
                    disableEdit={disableEdit}
                  />
                </Item>
              </div>
            );
          }
          return null;
        }}
      </Item>
    </SectionWrapper>
  );
};
export default Destination;
